import { useInitAnalytics, Environment, Region } from '@chewy/use-analytics';
import { ReactNode } from 'react';

type ChewyAnalyticsProps = {
  appName?: string;
  appVersion?: string;
  awsRegionShort?: string;
  environment?: string;
  children: ReactNode;
  pageType?: string;
};

export const ChewyAnalyticsWrapper = ({
  appName = 'pet-insurance',
  appVersion = '1.0.0',
  awsRegionShort = 'use1',
  environment = 'dev',
  pageType = 'pet-insurance',
  children,
}: ChewyAnalyticsProps): JSX.Element => {
  const analyticsConfig = {
    appName,
    appVersion,
    environment: environment as Environment,
    region: awsRegionShort as Region,
    pageType,
  };

  useInitAnalytics(analyticsConfig);

  return <>{children}</>;
};
